import { render, staticRenderFns } from "./LandingPageMiddleware.vue?vue&type=template&id=a4f63358&"
import script from "./LandingPageMiddleware.vue?vue&type=script&lang=js&"
export * from "./LandingPageMiddleware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports